import { Stack, Title, Text, Button } from '@repletoryreach/sdk-ui';
import { useNavigate } from 'react-router-dom';
import { useT } from '../../../i18n/I18nProvider';

/**
 * Reserved route. The 2FA login challenge runs inline in the login form
 * (see pages/auth/login/components/LoginForm.tsx); 2FA setup lives in
 * Settings → Security. This page exists so a deep link resolves cleanly.
 *
 * Nothing in the app links here, so anyone who arrives followed something
 * stale; which makes this a terminal state, and it is now styled as one
 * (`_UI_improvements/tenant/auth-mfa.md` §5). The single action was previously
 * a caption link, the smallest element on a page with exactly one thing to do.
 *
 * We deliberately keep the page rather than redirecting: the doc's alternative
 * (replace it with `<Navigate to="/auth/login">`) loses the explanation, and
 * this route is the stated landing spot if the challenge ever moves here.
 */
export default function MfaPage() {
  const t = useT();
  const navigate = useNavigate();

  return (
    <Stack gap="lg" align="center">
      <span className="rr-auth__icon-badge" aria-hidden><ShieldIcon /></span>
      <Stack gap="xs" align="center">
        <Title order={1} ta="center">{t('auth.mfa.title')}</Title>
        <Text role="bodySmall" c="var(--rr-color-text-muted)" ta="center">
          {t('auth.mfa.description')}
        </Text>
      </Stack>
      <Button fullWidth onClick={() => navigate('/auth/login')}>
        {t('auth.mfa.goToSignIn')}
      </Button>
    </Stack>
  );
}

function ShieldIcon() {
  return (
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M12 2.5l8 3.4v5.2c0 5.6-8 10.4-8 10.4s-8-4.8-8-10.4V5.9l8-3.4z" />
      <path d="M9 12l2.2 2.2L15.5 10" />
    </svg>
  );
}
